// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".radio-custom .custom-radio .custom-control-label[data-v-21f1432c],[data-v-21f1432c] .custom-radio .custom-control-label{margin-top:0}.checkbox-custom[data-v-21f1432c]  .custom-control-label{margin-top:2px}", ""]);
// Exports
module.exports = exports;
